const SENSITIVE_KEY = /password|passwd|token|secret|authorization|api[_-]?key|service[_-]?role|refresh[_-]?token|access[_-]?token|jwt|bearer|credential|anon[_-]?key|session/i;
const EMAIL_RE = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi;
const JWT_RE = /\beyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\b/g;
const UUID_RE = /\b[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}\b/gi;

const redactString = (text) => {
  if (typeof text !== 'string') return text;
  return text
    .replace(JWT_RE, '[redacted-token]')
    .replace(EMAIL_RE, '[redacted-email]')
    .replace(UUID_RE, '[redacted-id]');
};

const redactValue = (value, depth = 0) => {
  if (value == null) return value;
  if (depth > 5) return '[truncated]';
  if (typeof value === 'string') return redactString(value);
  if (typeof value !== 'object') return value;
  if (value instanceof Error) {
    return { name: value.name, message: redactString(value.message) };
  }
  if (Array.isArray(value)) return value.map((item) => redactValue(item, depth + 1));
  const out = {};
  Object.entries(value).forEach(([key, val]) => {
    if (SENSITIVE_KEY.test(key)) {
      out[key] = '[redacted]';
    } else {
      out[key] = redactValue(val, depth + 1);
    }
  });
  return out;
};

const sanitizeArgs = (args) => args.map((arg) => redactValue(arg));

export function installSecureConsole() {
  if (import.meta.env.DEV) return;

  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  console.table = noop;
  console.dir = noop;

  const origWarn = console.warn.bind(console);
  const origError = console.error.bind(console);

  console.warn = (...args) => origWarn(...sanitizeArgs(args));
  console.error = (...args) => origError(...sanitizeArgs(args));
}
